import { render } from "./newEnrolmentClass.vue?vue&type=template&id=7a0ab6cc&scoped=true"
import script from "./newEnrolmentClass.vue?vue&type=script&lang=js"
export * from "./newEnrolmentClass.vue?vue&type=script&lang=js"

import "./newEnrolmentClass.vue?vue&type=style&index=0&id=7a0ab6cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0ab6cc"]])

export default __exports__